export const REQUEST_USERS = 'REQUEST_USERS';
export const REQUEST_USER = 'REQUEST_USER';
export const UPDATE_FILTERS = 'UPDATE_USER_TRAITS_FILTER';
